var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBankIdGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 460,
    viewBox: "0 0 500 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51 0 0 1.51 248.19 230.06)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -95.2 -28.3)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-214.4, -228.2)",
    d: "M 251.3 263.4 l 13.2 -83.2 c -5.2 0 -14.1 0 -14.1 0 c -6.6 0 -15.1 -3.7 -17.6 -10.5 c -0.8 -2.3 -2.7 -10.2 8.2 -17.9 c 3.9 -2.7 6.4 -5.7 6.9 -8 c 0.5 -2.4 -0.1 -4.5 -1.8 -6.1 c -2.4 -2.3 -7.1 -3.6 -13.1 -3.6 c -10.1 0 -17.2 5.8 -17.9 10 c -0.5 3.1 1.9 5.6 4 7.2 c 6.3 4.7 7.8 11.5 3.9 17.9 c -4 6.6 -12.7 10.9 -22 11 c 0 0 -9.2 0 -14.4 0 c -1.2 8.1 -20.8 132.3 -22.3 142.1 h 77.8 C 242.8 318 246.4 294.5 251.3 263.4 L 251.3 263.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -129.77 121.9)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.83, -378.4)",
    d: "M 160.1 351.1 H 192 c 13.6 0 16.9 6.9 15.9 13.2 c -0.8 5.1 -4.3 8.9 -10.3 11.4 c 7.6 2.9 10.6 7.4 9.5 14.5 c -1.4 8.9 -9.1 15.5 -19.2 15.5 h -36.3 L 160.1 351.1 z M 181.2 373.7 c 6.2 0 9.1 -3.3 9.7 -7.2 c 0.6 -4.2 -1.3 -7.1 -7.5 -7.1 h -5.5 l -2.2 14.3 H 181.2 z M 177.8 397.2 c 6.4 0 10.1 -2.6 11 -7.9 c 0.7 -4.6 -1.9 -7.3 -8.1 -7.3 h -6.2 l -2.4 15.3 H 177.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -75.77 128)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-233.83, -384.5)",
    d: "M 251.8 406.1 c -8.3 0.6 -12.3 -0.3 -14.3 -3.9 c -4.4 2.7 -9.3 4.1 -14.5 4.1 c -9.4 0 -12.7 -4.9 -11.8 -10.3 c 0.4 -2.6 1.9 -5.1 4.3 -7.2 c 5.2 -4.5 18 -5.1 23 -8.5 c 0.4 -3.8 -1.1 -5.2 -5.8 -5.2 c -5.5 0 -10.1 1.8 -18 7.2 l 1.9 -12.4 c 6.8 -4.9 13.4 -7.2 21 -7.2 c 9.7 0 18.3 4 16.7 14.6 l -1.9 12 c -0.7 4.2 -0.5 5.5 4.2 5.6 L 251.8 406.1 z M 237.4 387.2 c -4.4 2.8 -12.6 2.3 -13.5 8.1 c -0.4 2.7 1.3 4.7 4 4.7 c 2.6 0 5.8 -1.1 8.4 -2.9 c -0.2 -1 -0.1 -2 0.2 -3.9 L 237.4 387.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -24.25 127.65)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-285.35, -384.15)",
    d: "M 267.3 363.4 h 16.6 l -0.9 5.5 c 5.3 -4.5 9.3 -6.2 14.5 -6.2 c 9.3 0 13.6 5.7 12.1 15 l -4.3 27.9 h -16.6 l 3.6 -23.1 c 0.7 -4.2 -0.6 -6.2 -3.8 -6.2 c -2.6 0 -5 1.4 -7.3 4.5 l -3.8 24.7 h -16.6 L 267.3 363.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 33.15 121.85)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-342.75, -378.35)",
    d: "M 322.6 351.1 h 16.6 l -4.2 26.8 l 15.9 -14.5 h 20.5 l -20.4 18 l 16.4 24.2 h -20.9 L 333.9 386 h -0.2 l -3 19.5 h -16.6 L 322.6 351.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 77.05 121.85)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-386.65, -378.35)",
    d: "M 381.3 351.1 h 19.1 l -8.4 54.5 h -19.1 L 381.3 351.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 122.28 121.85)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-431.88, -378.35)",
    d: "M 409.7 351.1 H 437 c 21.1 0 27.2 15.3 25.2 28 c -1.9 12.4 -11.7 26.5 -30.2 26.5 h -30.8 L 409.7 351.1 z M 427.4 392.6 c 9.3 0 14.4 -4.6 15.9 -14.3 c 1.1 -7.2 -1.1 -14.3 -11.4 -14.3 h -5.1 l -4.4 28.6 H 427.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 57.1 -41.5)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00807B",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-366.7, -215)",
    d: "M 355.9 107.5 h -79.5 l -10.6 67.3 l 13.5 0 c 7.4 0 14.4 -3.4 17.4 -8.3 c 1 -1.6 1.4 -3 1.4 -4.3 c 0 -2.8 -1.9 -4.9 -3.8 -6.3 c -5.2 -3.9 -6.3 -8 -6.3 -10.9 c 0 -0.6 0 -1.1 0.1 -1.6 c 1.1 -7.1 10.7 -14.8 23.4 -14.8 c 7.6 0 13.4 1.8 16.9 5.1 c 3.1 2.9 4.3 7 3.4 11.3 c -1.1 5.1 -6.2 9.3 -9.1 11.4 c -7.7 5.4 -6.7 10.1 -6.2 11.5 c 1.6 4.2 7.7 6.9 12.4 6.9 h 20.6 c 0 0 0 0 0 0.1 c 28 0.2 43 13.1 38.3 43.1 c -4.4 27.9 -25.8 39.9 -51.3 40.1 l -10.1 64.4 h 14.9 c 62.9 0 114.3 -40.4 124.4 -104.2 C 478.2 139.1 427.9 107.5 355.9 107.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -309.6,
    y: -256.5,
    rx: 0,
    ry: 0,
    width: 619.2,
    height: 513
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankIdGreen);
export default __webpack_public_path__ + "static/media/icon-bank-id-green.7ee6d17828912b0822ea198d6f9bc7bf.svg";
export { ForwardRef as ReactComponent };